import React from "react";
import classNames from "classnames/bind";

import styles from "./Section.module.scss";
const cx = classNames.bind(styles);

const Section = ({ children }) => {
  return <div className={cx("section-root")}>{children}</div>;
};

export default Section;
